import React, {useEffect, useRef, useState} from "react"
import style from "./tinyDropdown.module.scss"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"

const TinyDropdown = (props) => {


    const wrapperRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false)
    const [dropdownList, setDropdownList] = useState([])
    const [selectedItem, setSelectedItem] = useState("")
    const toggleShow = () => {
        setShowDropdown(!showDropdown);
        if (!showDropdown && props.onblure) {
            props.onblure();
        }
        if (!showDropdown && props.hasCheckbox) {
            let tmp = [];
            if (props.hasCheckbox) {
                tmp = props.dropdownList
            } else {
                tmp = props.dropdownList;
            }
            setDropdownList(tmp)
        }
    }
    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowDropdown(false);
            if (!showDropdown && props.onblure) {

            }
        }
    };

    useEffect(() => {
        if (!showDropdown && selectedItem) {
            props.selected(selectedItem)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDropdown])


    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    useEffect(() => {
        if (props.dropdownList && props.dropdownList.length !== 0) {
            setDropdownList(props.dropdownList)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.dropdownList]);

    useEffect(() => {
        if (props.selectedItem) {
            setSelectedItem(props.selectedItem)
        }
    }, [props.selectedItem]);

    return (
        < React.Fragment>
            <div className={style.dropdownWrapper} ref={wrapperRef}>
                <label>{props.label ? props.label : ''}</label>
                <div className={style.buttonWrapper}>

                    <button
                        onClick={toggleShow}
                        className={style.dropdownButton}
                        type="button">
                        {selectedItem ? toPersianNumber(selectedItem) : toPersianNumber(props.placeholder)}
                        <p className={showDropdown ? style.dropdownArrow : style.dropdownArrowClicked} alt=''>c</p>
                    </button>
                </div>


                <div className={showDropdown ? style.contentDiv : style.contentHideDiv}>

                    {dropdownList.length !== 0 ? dropdownList.map((item, index) =>


                        < p className={style.dropdownItemText} onClick={() => {
                            setSelectedItem(item);
                            setShowDropdown(false)
                        }} key={index}>
                            {toPersianNumber(item)}
                        </p>
                    ) : null}
                </div>


                {!showDropdown ? <p className={style.errorMessageRed}>{props.errorMessage}</p> :
                    <p className={style.errorMessageRed}></p>}
            </div>
        </React.Fragment>
    )
}
export default TinyDropdown;

/*

*
 */
